import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

// Setting a default clears the previous one, so the whole list is re-selected rather than the
// single row this mutation touched.
const mutation = graphql`
	mutation updateQuoteContentBlockMutation($input: UpdateQuoteContentBlockInput!) {
		updateQuoteContentBlock(input: $input) {
			company {
				id
				quoteContentBlocks {
					id
					sectionType
					name
					bodyJson
					isDefault
				}
			}
			quoteContentBlock {
				id
				sectionType
				name
				bodyJson
				isDefault
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {
		input: {
			csrfToken: Util.getCsrfValue(),
			socketClientId: Util.getClientId(),
			...input,
		},
	};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
